var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-textarea',{attrs:{"model":_vm.schema.comment}})}
var staticRenderFns = []

export { render, staticRenderFns }